import * as S from "./styles";
import { useScreenSize } from "../../hooks/useScreenSize";
import Button from "../../components/button";
import Footer from "../../components/footer";
import { doubts } from "./db";
import { useState } from "react";

const SectionDoubts = () => {
	const dimension = useScreenSize();
  const [limitDoubts, setLimitDoubts] = useState(5)

  return (
    <S.SectionDoubts id="toDoubts" data-section="section_duvidas-frequentes">
      <div className="container">
        <h2>Dúvidas frequentes</h2>

        <div className="doubts">
          {doubts.map((doubt, index) => {
            if(index < limitDoubts) {
              return (
                <details key={doubt.title} className="collapse" open={doubt?.open}>
                  <summary className="title" dangerouslySetInnerHTML={{__html: doubt.title}}></summary>
                  <div className="description" dangerouslySetInnerHTML={{__html: doubt.description}}></div>
                </details>
              )
            }
            return null
          })}
        </div>

        {limitDoubts <= doubts.length && (
          <Button
            label="VER MAIS"
            fontSize={dimension.width > 1366 ? "23" : "20"}
            height={dimension.width > 1366 ? "86" : "75"}
            width={dimension.width > 1366 ? "393" : "234"}
            padding={dimension.width > 1366 ? "0" : "25"}
            weight={900}
            dataElement="button_ver-mais"
            action={() => setLimitDoubts(limitDoubts + 5)}
          />
        )}
      </div>
      <Footer/>
    </S.SectionDoubts>
  )
}

export default SectionDoubts